/**
 * Gets a cookie by name
 *
 * @param {String} name - the cookie name to search for
 *
 * @return {String}
 */

const _getCookieName = (name) => {
  const result = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
  return result ? result.pop() : "";
};

/**
 * Parses the user data exists condition
 *
 * @param {Boolean} existsOption - determines to check for a positive or negative condition (e.g. "exist" or "does not exist")
 * @param {Object} condition - contains the conditions to check for
 *
 * @return {Boolean}
 */
const parseExistsConditions = (existsOption, condition) => {
  const { user_data_selector } = condition;

  const cookie = _getCookieName(user_data_selector);

  return existsOption ? !!cookie : !cookie;
};

/**
 * Parses the user data contains condition
 *
 * @param {Boolean} containsOption - determines to check for a positive or negative condition (e.g. "contains data" or "does not contain data")
 * @param {Object} condition - contains the conditions to check for
 *
 * @return {Boolean}
 */
const parseContainsDataConditions = (containsOption, condition) => {
  const { user_data_selector, condition: userDataCondition } = condition;

  const cookie = _getCookieName(user_data_selector);

  if (!cookie) return false;

  return containsOption
    ? cookie.includes(userDataCondition)
    : !cookie.includes(userDataCondition);
};

/**
 * Parses the user data equals condition
 *
 * @param {Boolean} equalsOption - determines to check for a positive or negative condition (e.g. "equals data" or "does not equal data")
 * @param {Object} condition - contains the conditions to check for
 *
 * @return {Boolean}
 */
const parseEqualsDataConditions = (equalsOption, condition) => {
  const { user_data_selector, condition: userDataCondition } = condition;

  const cookie = _getCookieName(user_data_selector);

  if (!cookie) return false;

  return equalsOption
    ? cookie === userDataCondition
    : cookie !== userDataCondition;
};

/**
 * Runs the user data display engine, passes off work to smaller functions
 *
 * @param {Object} condition - object containing conditions
 *
 * @return {Boolean}
 */
export default (condition) => {
  const { options } = condition;

  switch (options) {
    case "exists":
      return parseExistsConditions(true, condition);

    case "does not exist":
      return parseExistsConditions(false, condition);

    case "contains data":
      return parseContainsDataConditions(true, condition);

    case "does not contain data":
      return parseContainsDataConditions(false, condition);

    case "equals data":
      return parseEqualsDataConditions(true, condition);

    case "does not equal data":
      return parseEqualsDataConditions(false, condition);
  }
};
